import React from "react";
import { FloatNav, FloatNavGroup, FloatNavLink } from "../../../components";
import { useTranslate } from "../../../helpers";
import { PlanDetailsSection as PDS } from "../../../@types";

const Navigation: React.FunctionComponent<{
  hasAbstractBenefits: boolean;
  hasDrugs: boolean;
  hasDrugCosts: boolean;
}> = ({ hasAbstractBenefits, hasDrugs, hasDrugCosts }) => {
  const t = useTranslate();

  return (
    <FloatNav>
      <FloatNavGroup header={t("plan_terms.overview")}>
        <FloatNavLink id={PDS.PREMIUM} label={t("plan_terms.premium")} />
        <FloatNavLink id={PDS.DEDUCTIBLE} label={t("plan_terms.deductible")} />
      </FloatNavGroup>
      <FloatNavGroup header={t("plan_terms.drug_coverage_and_costs")}>
        {hasAbstractBenefits && (
          <FloatNavLink
            id={PDS.COSTS_BY_DRUG_TIER}
            label={t("abstract_benefits.title")}
          />
        )}
        {hasDrugs && (
          <FloatNavLink
            id={PDS.PHARMACIES}
            label={t("plan_card.section_heading.pharmacies")}
          />
        )}
        {hasDrugs && hasDrugCosts && (
          <FloatNavLink
            id={PDS.ESTIMATED_DRUG_COSTS}
            label={t("plan_details.drug_costs.estimated_coverage")}
          />
        )}
        {hasDrugs && hasDrugCosts && (
          <FloatNavLink
            id={PDS.OTHER_DRUG_INFO}
            label={t("plan_terms.other_drug_information")}
          />
        )}
        {hasDrugs && (
          <FloatNavLink
            id={PDS.MY_DRUG_LIST}
            label={t("plan_terms.my_drug_list")}
          />
        )}
        <FloatNavLink
          id={PDS.PART_B_DRUGS}
          label={t("plan_terms.medicare_part_b_drugs")}
        />
      </FloatNavGroup>
      <FloatNavGroup header={t("plan_stars.medicare.star_ratings")}>
        <FloatNavLink
          id={PDS.STAR_RATINGS}
          label={t("plan_stars.medicare.star_ratings")}
        />
      </FloatNavGroup>
      <FloatNavGroup header={t("plan_terms.documents_and_contact_information")}>
        <FloatNavLink
          id={PDS.CONTACT_INFO}
          label={t("plan_terms.contact_information")}
        />
      </FloatNavGroup>
    </FloatNav>
  );
};

export default Navigation;
